export default {
  common: {
    getDataFailed: 'Не удалось получить данные',
    cancel: 'Отмена',
    noResult: 'безрезультатно',
    prize: 'награждать',
    totalPrize: 'общая премия',
    round: 'Раунд',
    time: 'Время',
    address: 'Адрес',
    options: 'Варианты',
    type: 'Тип',
    none: 'Нет',
    executedSuccessfully: 'выполнена успешно',
  },
  header: {
    referral: 'Рекомендация',
    connect: 'Соединять',
    records: 'Мои записи',
    register: 'Оплата/ставка',
    disconnect: 'Отключение',
    networkHint: ' Обратите внимание на задержки в сети',
  },
  rules: {
    top: 'Готовы ли вы к вызову? У нас есть 12 вопросов, и в одном раунде победители могут разделить призовой фонд в размере 10,000 долларов США.',
    title: 'Правила',
    section1: 'Крайний срок подачи заявок — 12:00 по Гринвичу, а мероприятие начинается в 12:05 по Гринвичу.',
    section2: "Вам нужно поставить Lifeform Avatar и заплатить 1 BUSD, чтобы зарегистрироваться на это событие; если у вас нет Lifeform Avatar, вам нужно заплатить 20 BUSD, чтобы зарегистрироваться на это событие.",
    section3: 'Всего 12 вопросов.Для вопроса у вас есть 20 секунд, чтобы выбрать ответ, а правильный ответ будет показан в течение оставшихся 5 секунд. Если вы ответили правильно, вы можете перейти к следующему вопросу.',
    section4: 'По окончании раунда вы можете отменить ставку.',
    section5: 'Призы будут раздаваться победителям после каждого раунда конкурса.',
    section6: 'Отправьте реферальную ссылку своим друзьям, чтобы получить карту воскрешения.[Как только он/она воспользуется вашей ссылкой и зарегистрируется для участия в событии SuperAvatar, вы получите карту воскрешения]. ',
    section7: 'Вы можете использовать карту воскрешения для продолжения игры.Каждая карта воскрешения дает только один шанс за раунд. ',
    section8: 'Срок действия неиспользованных карт воскрешения автоматически истекает после каждого раунда.',
  },
  home: {
    prizePool: 'Призовой фонд',
    totalParticipants: 'Количество участников',
    round: 'Раунд',
    startIn: 'начинать',
    connect: 'Соединять',
    register: 'Регистрация',
    registered: 'Уже зарегистрирован',
    enter: 'Вступил',
    ongoing: 'Выполняется',
    ended: 'Завершился',
    cumulativeRanking: 'Кумулятивный рейтинг',
  },
  register: {
    registerRecords: 'Регистрационная запись',
    registerForRound: 'Раунд регистрации',
    youCanChoose: 'Вы можете выбрать',
    pay: 'Оплатить',
    or: 'или же',
    stake: 'Заложить',
    staked: 'заложен',
    paid: 'оплачен',
    inviteFriends: 'Приглашайте друзей',
    insufficientFunds: 'Недостаточный баланс',
    registerSuccess: 'Успешная регистрация',
    registerFail: 'Неудачная регистрация',
    onceRegistered: 'После успешной регистрации, вы можете получить памятный значок этого раунда SuperAvatar',
    checkMyMedal: 'Просмотреть мой памятный значок',
    backToHome: 'вернуться на главную страницу ',
  },
  records: {
    myTotalPrize: 'Мой общий бонус',
    myRecordsInSuperAvatar: 'Моя запись в super avatar ',
    round: 'Раунд',
    totalRegistered: 'Количество участников',
    totalPrize: 'общая премия',
    winners: 'Победитель',
    defeat: 'Поражение',
    myPrize: 'Мой бонус',
    myRecordsOfPayStake: 'Моя запись платежа/залога',
  },
  share: {
    share: 'Поделиться',
    referralUrlCopied: 'Скопированная ссылка-приглашение',
    showItOff: 'Похвастайтесь',
    invitingYouTo: 'приглашает вас',
    theWinnersTakeAll: 'Победитель получает все',
    yourReferralUrl: 'Ваша реферальная ссылка',
    downloadAndShare: 'Скачивайте картинки и делитесь',
    comeToWin: 'Приходите на super avatar, чтобы получить бонус!',
    iHaveDefeated: 'Я обыграл',
    ofThePlayers1: 'игроков',
    ofThePlayers2: 'и почти получил',
    isTheWinnerOfThisRound: 'победили в этом раунде',
    hasWon: 'Уже выиграл',
    comeToTogether: 'Давайте выиграем больше бонусов вместе',
    hereRecordOf: 'Вот запись игры',
    knowMore: 'Узнайте больше о super avatar',
    iHaveWon: 'Я выиграл',
    everyDay: 'каждый день',
    resurrectionCardUsed: 'Использована карта воскрешения',
    everyDay12GMTAAnswer: 'Каждый день в 12:00 (GMT) правильно отвечайте на 12 вопросов и сразу делите 10000 BUSD поровну. Участвуйте по ссылке:',
    totalHighAs: 'общая премия',
    everyDay12GMT: 'Каждый день в 12:00 (GMT)',
    answer12Today1: 'Ответьте правильно на 12 вопросов, победители',
    answer12Today2: 'разделят весь приз дня поровну',
    numIHaveDefeated: 'Я обыграл ',
    numOfThePlayers1: 'игроков',
    numOfThePlayers2: 'и почти получил',
    holdDownShare: 'Удерживайте фотографию, чтобы поделиться',
    win: 'победить',
  },
  stake: {
    registerByStaking: 'Регистрация со ставкой',
    unstakeAllAvatar: 'unstake all avatar',
    chooseYourAvatar: 'Выбор ваш avatar',
    stake: 'Заложить',
    unstake: 'Отмена ставки',
    unstaked: 'Залог был отменен',
    approveToken: 'Пожалуйста, авторизуйте своего агента для регистрации',
    approveNFT: 'Пожалуйста, авторизуйте свой NFT для залога',
  },
  match: {
    watching: 'Смотрит',
    sorryYouAreOut: 'Жаль, что вы проиграли!',
    wishNext: 'Надеюсь, вы выиграете в следующей игре!',
    totalPrize: 'общая премия',
    survivedAndTotal: 'Выживание/Количество участников',
    prizeForEach: 'Бонус для всех',
    rememberTo: 'remember to',
    unstakeYourAvatar: 'unstake your avatar',
    congrats: 'Поздравление!',
    areWinner: 'Вы победили в этом раунде.',
    almostWinner: 'Вас почти назвали победителем!',
    keepLearning: 'Продолжайте учиться, побеждайте в следующем раунде!',
    toGetCard: 'Получайте карту воскрешения на следующий раунд',
  },
  referral: {
    currentRound1: 'Это раунд',
    currentRound2: 'теперь',
    inviteYourFriendsTo: 'Пригласите своих друзей, чтобы получить этот раунд карт воскрешения!',
    referralRecords: 'Рекомендательная запись',
    round: 'Раунд',
    resurrectionCard: 'карта воскрешения',
    usedOrNot: 'Используется или нет',
    invitedUsers: 'Приглашенные пользователи',
    used: 'Уже использовались',
    unused: 'Не используется',
    none: 'Нет',
    viewDetails: 'Подробности просмотра',
  },
};